import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  container: css`
    padding: 12px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;

    &.align-right {
      align-items: flex-end;
    }
  `,

  fileList: css`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  `,

  fileCard: css`
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    margin: 8px 0;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    min-width: 260px;
    max-width: 280px;
    min-height: 64px;
    transition: all 0.2s ease;

    &:hover {
      background: #f5f5f5;
      border-color: #e0e0e0;
    }

    /* align=right 时图标在右侧 */
    &.align-right {
      flex-direction: row-reverse;
    }

  `,

  fileCardSmall: css`
    gap: 6px;
    min-width: 0;
    max-width: 260px;
    width: auto;
    height: 32px;
    min-height: 32px;
    margin: 0;
    padding: 4px 10px 4px 8px;
    border-radius: 7px;
    background: #f5f5f5;
    border-color: transparent;
    box-sizing: border-box;

    &:hover {
      background: #eeeeee;
      border-color: transparent;
    }

    .ant-progress-line {
      width: auto;
    }
  `,

  imageThumbnail: css`
    position: relative;
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f5f5f5;
    border: 1px solid rgba(0, 0, 0, 0.06);

    .ant-image {
      width: 100% !important;
      height: 100% !important;
      display: flex !important;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
    }

  `,

  imageThumbnailSmall: css`
    width: 22px;
    height: 22px;
    border-radius: 5px;
  `,

  imageOverlay: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  `,

  fileIcon: css`
    font-size: 24px;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

  `,

  fileIconSmall: css`
    width: 20px;
    height: 20px;
    font-size: 16px;
  `,

  fileInfo: css`
    flex: 1;
    min-width: 0;
    overflow: hidden;
  `,

  fileName: css`
    font-size: 13px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

  `,

  fileNameSmall: css`
    max-width: 190px;
    margin-bottom: 0;
    font-size: 12px;
    line-height: 20px;
  `,

  fileSize: css`
    font-size: 11px;
    color: #8c8c8c;

  `,

  fileSizeSmall: css`
    display: none;
  `,

  progress: css`
    margin-top: 4px;

    .ant-progress-inner {
      height: 4px !important;
    }

    .ant-progress-bg {
      height: 4px !important;
    }

  `,

  progressSmall: css`
    position: absolute;
    left: 34px;
    right: 10px;
    bottom: 3px;
    margin-top: 0;
    line-height: 0;

    .ant-progress-outer {
      display: block;
      width: 100%;
      padding-inline-end: 0 !important;
    }

    .ant-progress-inner {
      height: 3px !important;
      background: rgba(22, 119, 255, 0.12);
    }

    .ant-progress-bg {
      height: 3px !important;
    }
  `,

  fileRemoveBtn: css`
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    padding: 0;
    font-size: 10px;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.9);
      transform: scale(1.1);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,

  fileRemoveBtnSmall: css`
    top: -5px;
    right: -5px;
    width: 14px;
    height: 14px;
    font-size: 8px;
  `,

  fileLink: css`
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(0, 0, 0, 0.85);
    text-decoration: none;
    font-size: 13px;

    &:hover {
      color: #1677ff;
    }
  `,

  mediaWrapper: css`
    margin-top: 6px;

    audio {
      width: 100%;
      height: 32px;
      outline: none;
    }

    video {
      width: 100%;
      max-height: 240px;
      border-radius: 4px;
      outline: none;
      background: #000;
    }
  `,

  // ========== 图片展示模式 ==========
  imagePreviewMode: css`
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f5f5f5;
    border: 1px solid rgba(0, 0, 0, 0.06);

    .ant-image {
      display: flex !important;
      justify-content: center;
      align-items: center;
    }

    img {
      display: block !important;
      object-fit: contain !important;
    }
  `,

  imageFullMode: css`
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f5f5f5;
    border: 1px solid rgba(0, 0, 0, 0.06);
    width: 100%;

    .ant-image {
      width: 100% !important;
      display: flex !important;
    }

    img {
      width: 100% !important;
      display: block !important;
      object-fit: contain !important;
    }
  `,

  // ========== 图片加载状态 ==========
  imageLoadingSkeleton: css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #f5f5f5 25%, #e8e8e8 50%, #f5f5f5 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;

    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `,

  imageErrorFallback: css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    color: #bfbfbf;
    font-size: 20px;
    gap: 4px;

    span {
      font-size: 11px;
      color: #bfbfbf;
    }
  `,

  // ========== Media Card 模式 ==========
  mediaCardPlayIcon: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 2;
  `,
}));

export default useStyles;
